import { memo } from 'react';

import { VideoFrameRatesSelect } from '~/components/Filters/VideoFrameRateFilter/components/VideoFrameRatesSelect';
import { type BaseStringSelectProps } from '~/components/StringSelect';
import { usePrivateVideoFrameRatesList } from '~/swr-hooks/filters/usePrivateVideoFrameRatesList';

type PrivateVideoFrameRatesSelectProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateVideoFrameRatesSelect = memo(
  ({ boardId, libraryId, ...props }: PrivateVideoFrameRatesSelectProps) => {
    const { data = [], isLoading } = usePrivateVideoFrameRatesList({
      boardId,
      libraryId,
    });

    return <VideoFrameRatesSelect isLoading={isLoading} frameRates={data} {...props} />;
  },
);

PrivateVideoFrameRatesSelect.displayName = 'PrivateVideoFrameRatesSelect';
